import React from 'react';
import { useAppContext } from '../context/AppContext'; // Import useAppContext

/**
 * HomePage component that serves as the landing page for the application.
 * Displays basic instructions for users.
 */
const HomePage = () => {
  const { t } = useAppContext(); // Get t function

  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center p-12 bg-white rounded-lg shadow-sm max-w-2xl">
        <h1 className="text-2xl font-semibold mb-6">{t('homepage.welcome')}</h1>
        {/* Language switching buttons removed as per user request */}
        <p className="text-lg text-gray-700 mb-8">
          {t('homepage.startSearching')}
        </p>
        <p className="text-med text-gray-700 mb-8">
          {t('homepage.selectSearchType')}
        </p>
        <div className="flex justify-center">
          <div className="bg-gray-100 p-4 rounded-lg">
            <p className="text-sm text-gray-600">
              {t('homepage.useSidebar')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
